import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/5 py-20 overflow-hidden relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center">
          <motion.img 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ rotate: 360, scale: 1.2 }}
            transition={{ duration: 1 }}
            src="https://grafiken.trust-franken.de/HP/Kreuz.png" 
            alt="Trust MC Logo" 
            className="h-24 w-auto mb-12 cursor-pointer filter grayscale hover:grayscale-0 transition-all"
          />

          <div className="flex flex-wrap justify-center gap-12 mb-16">
            {['Impressum', 'Datenschutz'].map((text) => (
              <Link 
                key={text}
                to={`/${text.toLowerCase()}`} 
                className="relative text-gray-500 hover:text-white uppercase tracking-[0.3em] text-sm font-bold transition-colors group"
              >
                {text}
                <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full" />
              </Link>
            ))}
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="flex flex-col md:flex-row justify-between items-center w-full pt-12 border-t border-white/5 text-xs uppercase tracking-[0.2em] text-gray-600 gap-8"
          >
            <p>© 2026 Trust MC Franken. All Rights Reserved.</p>
            <motion.div 
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-2"
            >
              Crafted by{' '}
              <a 
                href="https://lima-service.de" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white hover:text-gray-400 transition-colors font-black"
              >
                LIMA-Service
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;